import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { HttpService } from 'app/core/http/http.service';
import * as Models from 'app/core/models';

/**
 * Provides a base for authentication workflow.
 * The Credentials interface as well as login/logout methods should be replaced with proper implementation.
 */
@Injectable()
export class AuthenticationService {

  _authenticationStatusChange = new Subject<boolean>();
  authenticationStatusChange$ = this._authenticationStatusChange.asObservable();

  constructor(private http: HttpService) {
    this.http.authenticationStatusChange$.subscribe(data => {
      this._authenticationStatusChange.next(data);
    });
  }

  /**
   * Authenticates the user.
   * @param {LoginContext} context The login parameters.
   * @return {Observable<Credentials>} The user credentials.
   */
  login(context: Models.LoginContext): Observable<Models.Credentials> {
    // Replace by proper authentication call
    return this.http.post('User/login', JSON.stringify(context), { cache: false })
      .map((res: Response) => res.json());
  }

  signup(context: Models.SignUpInput): Observable<any> {
    const data = this.ConvertSignUpInput(context);
    return this.http.post('user/signUp', JSON.stringify(data), { cache: false })
  }

  /**
   * Logs out the user and clear credentials.
   * @return {Observable<boolean>} True if the user was logged out successfully.
   */
  logout(): Observable<boolean> {
    this.http.post('User/logout', '', { cache: false }).subscribe();
    this.http.setCredentials();
    return Observable.of(true);
  }

  logoutAction(): void {
    this.http.post('User/logout', '', { cache: false }).subscribe();
    this.http.setCredentials();
  }

  confirmEmail(context: Models.EmailConfirmation): Observable<Models.Credentials> {
    return this.http.post('user/confirmEmail', JSON.stringify(context), { cache: false })
      .map((res: Response) => res.json());
  }

  forgotPassword(context: Models.ForgotPassword): Observable<any> {
    return this.http.post('user/forgotPassword', JSON.stringify(context), { cache: false })
  }

  resetPassword(context: Models.ResetPassword): Observable<any> {
    return this.http.post('user/resetPassword', JSON.stringify(context), { cache: false })
  }

  /**
   * Checks is the user is authenticated.
   * @return {boolean} True if the user is authenticated.
   */
  isAuthenticated(): boolean {
    return !!this.http.credentials;
  }

  public get credentials(): Models.Credentials {
    return this.http.credentials;
  }

  public setCredentials(credentials?: Models.Credentials, remember?: boolean) {
    this.http.setCredentials(credentials, remember);
  }

  private ConvertSignUpInput(input: Models.SignUpInput): Models.SignUpOutput {
    const result: Models.SignUpOutput = {
      email: input.email,
      password: input.password,
      profile: {
        firstName: input.firstName,
        lastName: input.lastName,
        email: input.email,
        userInterests: [],
        userSpecialities: []
      }
    };
    return result;
  }

}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/core/authentication/authentication.service.ts